import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Model = () => {
  const { typeId } = useParams();  // Pobieranie typeId z URL
  const navigate = useNavigate();

  // Definiowanie stanu dla models i setModels
  const [models, setModels] = useState([]);

  useEffect(() => {
    async function fetchModels() {
      try {
        const response = await axios.get(`http://161.97.115.122:5000/model/${typeId}`);
        setModels(response.data);  // Ustawianie danych modeli
      } catch (error) {
        console.error("Błąd podczas pobierania modeli:", error);
      }
    }

    fetchModels();
  }, [typeId]);  // Dependencja na typeId, dzięki czemu useEffect uruchamia się ponownie gdy typeId się zmienia

  return (
 <div className="app-container">
    <div className="sidebar">
     <img className="logo" src="https://agrofrankopol-sklep.pl/wp-content/uploads/2022/05/logo-1024x635.png" alt="Logo" />

  <div className="menu">
 
    <ul>
            <li><a href="http://161.97.115.122:3000/">Strona Główna</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/">Sklep internetowy</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/kontakt/">Kontakt</a></li>
    </ul>
</div>
    </div>
    <div className="content">
                    <button onClick={() => navigate(-1)} className="back-button">Wstecz</button>

    <div className="katalog">
      <h1>Modele</h1>
      <ul>
        {models.map(model => (
        
        
           <li key={model._id} className="type-item">
         <div className="type-image">
          </div>
          <div className="type-info">
            <Link to={`/list-type/${model._id}`} className="type-link">
              {model.nazwa}
            </Link>
          </div>
        </li>
      ))}
        
        
      </ul>
    </div>
    </div>
    </div>
  );
}

export default Model;
